import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { toArray } from "./toArray.js";
export const first = (source, predicate) => {
    if (predicate) {
        return first2(source, predicate);
    }
    else {
        return first1(source);
    }
};
const first1 = async (source) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            if (values.length === 0) {
                throw new InvalidOperationException(ErrorString.NoElements);
            }
            else {
                return values[0];
            }
        }
        case 1: {
            const promises = dataFunc.generator();
            if (promises.length === 0) {
                throw new InvalidOperationException(ErrorString.NoElements);
            }
            else {
                return await promises[0];
            }
        }
        case 2: {
            const promises = await dataFunc.generator();
            if (promises.length === 0) {
                throw new InvalidOperationException(ErrorString.NoElements);
            }
            else {
                return await promises[0];
            }
        }
    }
};
const first2 = async (source, predicate) => {
    const data = await toArray(source);
    for (const value of data) {
        if (predicate(value) === true) {
            return value;
        }
    }
    throw new InvalidOperationException(ErrorString.NoMatch);
};
